import { useStore } from "../../stores/StoreContext";
import { SummaryService } from "../LogicServices/SummaryService";

export function useSummaryService(): SummaryService {
  const storeContext = useStore();
  return new SummaryService(storeContext);
}
